import { formatNumber } from '@trmediaab/zebra-utils';
import classnames from 'classnames';
import { profitTypes } from 'live/components/index.shared';
import { GameType } from 'live/components/index.types';
import { liveSetSelectedGame } from 'live/redux/actions';
import PropTypes from 'prop-types';
import React from 'react';
import { useDispatch } from 'react-redux';

import userpic from 'images/joker_avatar.svg';
import Image from 'shared/components/Image';
import { formatDate, formatDateDayMonth } from 'shared/utils/dateUtils';
import { getProductDisplayName } from 'shared/utils/productUtils';
import { getText } from 'shared/utils/Text';

import styles from './index.module.scss';

const TopListItem = ({ full, game, position, showYear = false, type }) => {
  const dispatch = useDispatch();
  const onClick = data => dispatch(liveSetSelectedGame(data));

  const productName = getProductDisplayName(
    game.atgProduct || game.sportProduct || '',
  );
  const getDate = date =>
    showYear ? formatDateDayMonth(date) : formatDate(date);

  const additional = game.date
    ? `${productName} — ${getDate(game.date)}`
    : null;

  const isProfits = type === profitTypes[1];

  return (
    <div
      className={classnames(styles.container, {
        [styles.gold]: position === 1,
        [styles.silver]: position === 2,
        [styles.bronze]: position === 3,
        [styles.clickable]: isProfits,
      })}
      onClick={() => isProfits && onClick({ ...game, type: 'completed' })}
    >
      <div className={styles.img}>
        {game.imageId ? (
          <Image
            alt={game.alias}
            crop="thumb"
            gravity="face"
            imageId={game.imageId}
            ratio={[1, 1]}
            zoom="0.8"
            width={50}
          />
        ) : (
          <div className={styles.defaultUserpic}>
            <img alt={game.alias} src={userpic} />
          </div>
        )}
      </div>

      <div
        className={classnames(styles.texts, {
          [styles.full]: full,
        })}
      >
        <div className={styles.name}>
          {game.alias || game.name}
          {full && additional && (
            <div className={styles.additionalMobile}>, {additional}</div>
          )}
        </div>

        {full && additional && (
          <div className={styles.additional}>{additional}</div>
        )}

        <div className={styles.award}>
          {formatNumber(game.profit, {
            maximumFractionDigits: 0,
          })}
          &nbsp;
          {getText('currency-short')}
        </div>
      </div>
    </div>
  );
};

TopListItem.propTypes = {
  additional: PropTypes.string,
  full: PropTypes.bool,
  game: GameType,
  position: PropTypes.number,
  showYear: PropTypes.bool,
  type: PropTypes.oneOf(profitTypes),

  onClick: PropTypes.func,
};

export default TopListItem;
